/** The PostHog project events and feature flags belong to. */

import { env as publicEnv } from "$env/dynamic/public";
import { PUBLIC_POSTHOG_API_KEY } from "$env/static/public";

/**
 * The build bakes in the project of the environment it was built for, so
 * deployments that reuse an image for another environment — dev-cluster runs a
 * production build — set `PUBLIC_POSTHOG_API_KEY` to retarget it at runtime.
 */
export const posthogProjectApiKey: string =
  publicEnv.PUBLIC_POSTHOG_API_KEY || PUBLIC_POSTHOG_API_KEY;
